import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContentCheck, ContentRemove } from '@fs/zion-icon'
import { Separator, H5 } from '@fs/zion-ui'
import DmcDataView from '../../../common/DmcDataView'

export default function TssOdmData({ data }) {
  const { t } = useTranslation()

  const getDetail = (key, value) => {
    if (typeof value === 'boolean') {
      return value ? <ContentCheck size="xs" color="green" /> : <ContentRemove size="xs" color="red" />
    }
    const dateMatch = /\d{4}-\d{2}-\d{2}/.exec(value)
    if (dateMatch) {
      return dateMatch[0]
    }

    const mappedValues = {
      // ctrOfficialId block may be removed once ctrOfficialId is replaced by odmClassOfficial in prod
      ctrOfficialId: {
        462: t('ctr.summary.odmData.officialPrimary', 'Official Primary'),
        463: t('ctr.summary.odmData.officialSecondary', 'Official Secondary'),
        464: t('ctr.summary.odmData.officialUndetermined', 'Official Undetermined'),
        465: t('ctr.summary.odmData.unofficialPatron', 'Unofficial Patron'),
        466: t('ctr.summary.odmData.officialRestorationOfBlessings', 'Official Restoration of Blessings'),
      },
      odmClassOfficial: {
        O: t('ctr.summary.odmData.officialPrimary', 'Official Primary'),
        S: t('ctr.summary.odmData.officialSecondary', 'Official Secondary'),
        U: t('ctr.summary.odmData.officialUndetermined', 'Official Undetermined'),
        R: t('ctr.summary.odmData.officialRestorationOfBlessings', 'Official Restoration of Blessings'),
      },
      ctrStatusId: {
        253: t('ctr.summary.odmData.COMPLETED', 'Completed'),
        254: t('ctr.summary.odmData.CANCELLED', 'Cancelled'),
        255: t('ctr.summary.odmData.DELETED', 'Deleted'),
        258: t('ctr.summary.odmData.INVALID', 'Invalid'),
      },
    }
    return mappedValues[key]?.[value] || value
  }

  const displayData = Object.keys(data)
    .filter((key) => key !== 'ctrId')
    .map((key) => {
      return {
        label: <b>{t(`odm.data.${key}`, key)}</b>,
        detail: getDetail(key, data[key]),
        key: `odm-data-${key}`,
      }
    })

  return (
    <>
      <Separator />
      <H5>{t('ctr.summary.odmData', 'Raw TSS ODM Data')}</H5>
      <DmcDataView data={displayData} />
    </>
  )
}
